import { forwardRef } from 'react'

import type { DraggableProps, DraggableProvided } from 'react-beautiful-dnd'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Link, ListItem, Text,
} from '@domain-group/suit-theme'

import useCampaignQuoteSection from '@hooks/useCampaignQuoteSection'

interface DraggableCampaignQuoteSectionProps {
  campaignQuoteSectionId: number,
  draggableProps: DraggableProps,
  dragHandleProps: DraggableProvided['dragHandleProps'],
  dragSnapshot: {
    isDragging: boolean,
  },
}
const DraggableCampaignQuoteSection = forwardRef((props: DraggableCampaignQuoteSectionProps, ref) => {
  const {
    campaignQuoteSectionId, dragHandleProps, dragSnapshot, draggableProps,
  } = props

  const { isDragging } = dragSnapshot || {}

  const quoteSectionPayload = useCampaignQuoteSection({ id: campaignQuoteSectionId })
  const {
    campaignQuoteSection: { title },
  } = quoteSectionPayload

  return (
    <ListItem
      boxProps={{
        alignItems: 'center',
        backgroundColor: 'white',
        borderBottom: '1px dashed',
        borderColor: 'lineColor',
        paddingY: 'large',
      }}
      disableHover
      forwardProps={{
        ...draggableProps,
        ...dragHandleProps,
      }}
      isDragging={isDragging}
      // @ts-expect-error TS2322
      ref={ref}
    >
      <Box flexDirection="column" justifyContent="center" minWidth="0">
        <Text fontSize="small">{title}</Text>
      </Box>

      <Link greyLink textProps={{ fontSize: 'small', marginLeft: 'large' }}>
        <FontAwesomeIcon icon={faBars} />
      </Link>
    </ListItem>
  )
})

export default DraggableCampaignQuoteSection
